import React, { useEffect, useState } from "react";
import { Container } from "./style";
import TextArea from "../../../../components/FormElement/TextArea";
import Button from "../../../../components/FormElement/Button";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import Input from "../../../../components/FormElement/Search";
import DatePicker from "../../../../components/FormElement/DatePicker";
import LangTab from "../../../../components/FormElement/LangTab";
import { useFormik } from "formik";
import { useShowAlert } from "../../../../hooks/useAlerts";
import * as Yup from "yup";
import Spinner from "../../../../components/Spinner/FullScreen";
import service from "../../../../services/blog";
import { useHideModal } from "../../../../hooks";

const Form = ({ id, fetch }) => {
  const { hideModal } = useHideModal();
  const [language, setLanguage] = useState("UZL");
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();

  const validationSchema = Yup.object({
    author: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    study_time: Yup.string().required("Kiritish shart!"),
    date: Yup.string().required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      author: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      study_time: "",
      date: null,
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("author[UZL]", values.author.UZL);
      formData.append("author[RUS]", values.author.RUS);
      formData.append("author[UZK]", values.author.UZK);
      formData.append("author[ENG]", values.author.ENG);

      formData.append("title[UZL]", values.title.UZL);
      formData.append("title[RUS]", values.title.RUS);
      formData.append("title[UZK]", values.title.UZK);
      formData.append("title[ENG]", values.title.ENG);

      formData.append("desc[UZL]", values.desc.UZL);
      formData.append("desc[RUS]", values.desc.RUS);
      formData.append("desc[UZK]", values.desc.UZK);
      formData.append("desc[ENG]", values.desc.ENG);

      formData.append("study_time", values.study_time);

      formData.append("date", values.date);

      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`files`, el.originFileObj);
        }
      });
      setLoading(true);
      if (id) {
        service
          .update(id, formData)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      service
        .getOne(id)
        .then((resp) => {
          formik.setValues({
            author: {
              UZL: resp?.author?.UZL,
              UZK: resp?.author?.UZK,
              RUS: resp?.author?.RUS,
              ENG: resp?.author?.ENG,
            },
            title: {
              UZL: resp?.title?.UZL,
              UZK: resp?.title?.UZK,
              RUS: resp?.title?.RUS,
              ENG: resp?.title?.ENG,
            },
            desc: {
              UZL: resp?.desc?.UZL,
              UZK: resp?.desc?.UZK,
              RUS: resp?.desc?.RUS,
              ENG: resp?.desc?.ENG,
            },
            study_time: resp?.study_time,
            date: resp?.date,
          });
          setFileList(() =>
            resp?.media?.map((el) => {
              return el;
            })
          );
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);
  const onLangChange = (key) => {
    setLanguage(key);
  };

  if (loading) return <Spinner />;
  return (
    <Container>
      <form onSubmit={formik.handleSubmit}>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <Input
          id="author"
          name="author"
          label="F.I.SH"
          width={100}
          placeholder="F.I.SH"
          onChange={(e) => {
            formik.setFieldValue(`author.${language}`, e.target.value);
          }}
          value={formik.values?.author[language]}
          status={
            formik?.errors?.author && formik.touched.author ? "error" : ""
          }
        />
        <TextArea
          id="title"
          name="title"
          label="Sarlavha"
          width={100}
          placeholder="Yangilik sarlavhasi"
          onChange={(e) => {
            formik.setFieldValue(`title.${language}`, e.target.value);
          }}
          value={formik.values?.title[language]}
          status={formik?.errors?.title && formik.touched.title ? "error" : ""}
          height={"60px"}
        />
        <TextArea
          id="desc"
          name="desc"
          label="Tavsifi"
          width={100}
          placeholder="Yangilik tavsifi"
          onChange={(e) => {
            formik.setFieldValue(`desc.${language}`, e.target.value);
          }}
          value={formik.values?.desc[language]}
          status={formik?.errors?.desc && formik.touched.desc ? "error" : ""}
          height={"120px"}
        />
        <Input
          id="study_time"
          name="study_time"
          label="O'qish vaqti"
          type="number"
          width={100}
          placeholder="O'qish vaqti"
          onChange={formik.handleChange}
          value={formik.values?.study_time}
          status={
            formik?.errors?.study_time && formik.touched.study_time
              ? "error"
              : ""
          }
        />
        <div style={{ marginTop: "10px" }}>
          <DatePicker
            label="Sana"
            value={formik?.values?.date || null}
            onChange={(date) => formik.setFieldValue("date", date)}
            status={formik?.errors?.date && formik.touched.date ? "error" : ""}
          />
        </div>
        <div className="upload-wrapper">
          <ImageUpload
            maxCount={10}
            multiple={true}
            fileList={fileList}
            setFileList={setFileList}
            status={status && !fileList?.length ? true : false}
          />
        </div>
        <Button
          text={id ? "Tahrirlash" : "Saqlash"}
          htmlType="submit"
          width="100%"
        />
      </form>
    </Container>
  );
};

export default Form;
